import { configureStore } from "@reduxjs/toolkit";
import appSlice from "./features/slices/appSlice";
import cartReducer from "./features/slices/cartSlice";
import userSlice from "./features/slices/userSlice";
import formDataReducer from "./features/slices/formDataSlice";
import wishlistSlice from "./features/slices/wishlistSlice";
import notificationReducer from "./features/slices/notificationSlice";

export const store = configureStore({
  reducer: {
    app: appSlice,
    cart: cartReducer,
    users: userSlice,
    formData: formDataReducer,
    wishlist: wishlistSlice,
    notifications: notificationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
